module.exports = __webpack_public_path__ + "img/entrance_thumb.de4a0bdb.jpg";